import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { EaDisplay, EaSize } from '@app/components/pr-display';

@Component({
    selector: 'pr-button-add',
    templateUrl: './pr-button-add.component.html',
    styleUrls: ['./pr-button-add.component.scss'],
    standalone: false
})
export class PrButtonAddComponent {
  @Input() display: EaDisplay;
  @Input() size: EaSize;
  @Input() clazz: string;
  @Input() icon: string;
  @Input() rightIcon: string;
  @Input() iconWidth: number = 20;
  @Input() iconViewBoxWidth;
  @Input() iconViewBoxHeight;
  @Input() tooltip: string;
  @Input() label: string;
  @Input() type: string = 'button';
  @Input() disabled: boolean = false;

  @Output() onClick: EventEmitter<any> = new EventEmitter();

  constructor() {}

  click(event: Event) {
    this.onClick.emit(event);
  }
}
